/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SlashBoxIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABB0lEQVR4nN2VOwrCQBCGLXzU4iUED5E2GGdnFOKMgm0q8RrGTryLFp5DPIGPRjyAFkrAgHmo2U0sdGCq+We+3eVnp1T6m3Bdt6qIZ4B8UCQ3kwTivSLxg1kJQFAwHayS6ScAeU6u4olyTLuBxgBePz8DkPTjmjyAK4C0wj7LssqKeFMYAFDmkb6uTNJ0hgA+E40aYY/jDOuAfCoMAMTjaA8vXmm1AYCy9TyvEuo7vUETkC/FAbpiR/Qoq3d6LQAQL5+1iIP2pwPpAK5ZbGkMgIy2NARwZlsaAXRsqQ3QtaXSBpD0w5pt27Xgg8s6PBXwWBa3gnL31YUDKNMXK1P8PDeBdyvzZ+MOK5+uFUnoKNkAAAAASUVORK5CYII=)
 */
export const SlashBoxIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm12.79 3.37a.25.25 0 0 0-.22-.37h-3.13a.75.75 0 0 0-.66.38L6.21 18.63c-.1.16.03.37.22.37h3.13c.27 0 .52-.14.66-.38l7.57-13.25Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
